class RsnglrProduct {
  constructor(container) {
    this.container = container;
    this.form = container.querySelector('form.product-form');
    this.addButton = this.form?.querySelector('[type="submit"]');
    this.variantInput = this.form?.querySelector('input[name="id"]');
    this.priceEl = container.querySelector('[data-product-price]');
    this.optionInputs = Array.from(container.querySelectorAll('[data-option-value]'));
    this.selectedOptions = {};
    this.product = this.parseProduct();
    this.init();
  }

  parseProduct() {
    const el = this.container.querySelector('[data-product-json]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch { return null; }
  }

  init() {
    if (!this.product || !this.product.options?.length) return;
    this.product.options.forEach((opt, i) => {
      this.selectedOptions[opt.name] = opt.values[0];
    });
    this.updateSelection();
    this.optionInputs.forEach((input) => {
      input.addEventListener('click', (e) => this.onOptionClick(e));
    });
    this.form?.addEventListener('submit', (e) => this.onSubmit(e));
  }

  onOptionClick(e) {
    const btn = e.currentTarget;
    if (btn.disabled) return;
    const optionName = btn.dataset.optionName;
    const value = btn.dataset.optionValue;
    this.selectedOptions[optionName] = value;
    this.updateSelection();
  }

  findVariant() {
    if (!this.product) return null;
    return this.product.variants.find((v) =>
      this.product.options.every((opt) => {
        const sel = this.selectedOptions[opt.name];
        const val = v[`option${opt.position}`];
        return sel === val;
      })
    );
  }

  isAvailable(optionName, value) {
    if (!this.product) return false;
    const current = { ...this.selectedOptions, [optionName]: value };
    return this.product.variants.some((v) => {
      if (!v.available) return false;
      return this.product.options.every((opt) => {
        const wanted = current[opt.name];
        if (wanted === undefined) return true;
        return v[`option${opt.position}`] === wanted;
      });
    });
  }

  updateSelection() {
    const variant = this.findVariant();
    this.optionInputs.forEach((btn) => {
      const optName = btn.dataset.optionName;
      const val = btn.dataset.optionValue;
      const active = this.selectedOptions[optName] === val;
      const available = this.isAvailable(optName, val);
      btn.classList.toggle('active', active);
      btn.classList.toggle('unavailable', !available);
      btn.disabled = !available;
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    if (variant) {
      this.variantInput.value = variant.id;
      if (this.priceEl) {
        this.priceEl.textContent = `${variant.price / 100} ${window.shopCurrency}`;
      }
      if (this.addButton) {
        this.addButton.disabled = !variant.available;
        this.addButton.textContent = variant.available
          ? window.translations.addToCart
          : window.translations.soldOut;
      }
    } else if (this.addButton) {
      this.addButton.disabled = true;
      this.addButton.textContent = window.translations.unavailable;
    }
  }

  async onSubmit(e) {
    e.preventDefault();
    if (this.addButton) this.addButton.disabled = true;
    const variant = this.findVariant();
    if (!variant) return;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: 1 }),
      });
      if (!res.ok) throw new Error(res.statusText);
      window.rsnglrCart.open();
      window.rsnglrCart.fetch();
      if (this.addButton) {
        this.addButton.textContent = window.translations.added;
        setTimeout(() => this.updateSelection(), 1500);
      }
    } catch (err) {
      alert(window.translations.error);
      if (this.addButton) this.updateSelection();
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-form]').forEach((el) => new RsnglrProduct(el));
});
